import {$, _} from 'backboneAdapter'
import Handlebars from 'handlebars';
import GenericView from 'js/views/generic.view';
import Template from 'js/templates/custom.fields.hbs';
import CustomFieldsCollection from 'js/models/custom.fields.collection';
import CustomFieldModel from 'js/models/custom.field.model';
import CustomFieldPartialTemplate from 'js/templates/partials/custom.field.partial.hbs';
import i18n from 'l10n';
import {el, model, on, tagName, template} from "../adapters/backbone-decorators";
import dhtmlx from 'dhtmlxAdapter';

require('jqueryUI');

const customFieldPartialTemplate = Handlebars.compile(CustomFieldPartialTemplate);
const customFieldMultipleChoiceOptionTemplate = Handlebars.compile("{{> customFieldMultipleChoiceOption this}}");

@tagName('div')
@template(Template)
@el("#manage-custom-fields-container")
@model(CustomFieldModel)
class CustomFieldsView extends GenericView {
    customFieldPartialTemplate = customFieldPartialTemplate;
    customFieldMultipleChoiceOptionTemplate = customFieldMultipleChoiceOptionTemplate;
    customFieldInfo = null;

    constructor(options) {
        super(options);
        this.options = options;
        this.collectionUrl = this.model.url();
        this.collection = new CustomFieldsCollection();
        this.collection.url = this.collectionUrl;
        this.collection.on('add', item => this.addOne(item), this);
        this.collection.on('reset', () => this.addAll(this.collection, "customFields"), this);
        this.renderCollection();
    }

    render() {
        $("#customFieldsNumber").text(this.collection.length);
    }

    renderCollection() {
        this.collection.fetch().done(response => {
            $.each(response, function(index, elem) {
                elem.values = elem.values && elem.values != "" ? elem.values.split(",") : null;
            })

            $(this.el).html(this.template({customFields: response}));
            this.render();
        });
    }

    addAll(theCollection) {
        const $customFieldsTable = $("#customFieldsTable").find("tr.row-of-history");
        $customFieldsTable.remove(); //remove all `<tr>` children, except the `headers` one
        _.each(theCollection.data, item => {
            this.addOne(item, this);
        });
        this.render();
    }

    toggleVisibilityOfElement(element, display) {
        if (display === "toggle") {
            $(element).toggle();
        } else { //e.g. "display: none, block
            $(element).css("display", display);
        }
    }

    addOne(item) {
        const attrs = item.attributes ? item.attributes : item;
        $("<tr/>").addClass('row-of-history')
            .css('font-weight', 400)
            .data("user-id", attrs.id)
            .html(this.customFieldPartialTemplate(attrs));
        $("#customFieldsTable").append($("tr").addClass('row-of-history').css('font-weight', 400).data("user-id", attrs.id));
    }

    disableNewRedeemerFormButtons(toDisable) {
        const method = toDisable ? "attr" : "removeAttr";

        $("#name")[method]("disabled"); //Description Input
        $("#type")[method]("disabled");
        $("#cancelCreationOfCustomField")[method]("disabled"); //cancel (close form window) button
        $("#submitNewCustomField")[method]("disabled"); //submit new Redeemer button
        $(".customFieldSpinner").toggle(toDisable); //spinner
    }

    @on('change .selectCFType')
    showHideMultipleChoiceOptions(e) {
        const $select = $(e.currentTarget);
        const $mcOptions = $select.parent().parent().find(".multipleChoiceOptions");

        if($select.val() == 'multipleChoice') {
            $mcOptions.show();
            $mcOptions.find(".sortableMChoices").sortable();
        }else {
             $mcOptions.hide();
        }
    }

    @on('click #submitNewCustomField')
    submitNewCustomField(selectElements, selectElement, selfParam) {
        const name = $("#name").val();
        const type = $("#type").val();

        if (name === null || $.trim(name).length === 0) {
            dhtmlx.alert(i18n.t("engagement.fieldMustNotBeEmpty"));
            return;
        }
        if (type === null || $.trim(type).length === 0) {
            dhtmlx.alert(i18n.t("engagement.fieldMustNotBeEmpty"));
            return;
        }

        var data = {name: name, type: type};

        if (type == "multipleChoice") {
            const mChoices = $(".multipleChoiceOptions .customFieldMCOption");
            if(mChoices.length < 2) {
                dhtmlx.alert(i18n.t("customFieldAtLeastTwoChoices"));
                return;
            }

            var hasEmptyChoice = false;
            $.each(mChoices, function() {
                if($($(this)[0]).val().trim().length == 0) {
                    hasEmptyChoice = true;
                    $(this).addClass('invalidEmptyInput');
                }else {
                    $(this).removeClass('invalidEmptyInput');
                }
            });

            var hasDuplicateChoice = false;
            for(var i=0; i<mChoices.length; i++) {
                var curChoice = $(mChoices[i]).val();

                for(var j=0;j<mChoices.length; j++) {
                    var toCheck = $(mChoices[j]).val();
                    if(j != i) {
                        if(curChoice.toLowerCase() == toCheck.toLowerCase())
                            hasDuplicateChoice = true;
                    }
                }
            }

            if(hasEmptyChoice) {
                dhtmlx.alert(i18n.t("customFieldNoEmptyMultipleChoice"));
                return;
            }
            if(hasDuplicateChoice) {
                dhtmlx.alert(i18n.t("customFieldDuplicateMultipleChoice"));
                return;
            }
            data.values = $.map($(".multipleChoiceOptions").find("input"), function(input, index) {
                return $(input).val();
            });
        }


        this.disableNewRedeemerFormButtons(true);
        $.ajaxDefaultQ({
            url: `${this.collectionUrl}/create`,
            type: 'post',
            dataType: 'json',
            data: data
        }).done(response => {
            if (response.outcome === "OK") {
                $.Notify.show(i18n.t("customFieldCreatedSuccessfully"));
                this.renderCollection();
                $("#newCustomFieldForm").hide();
            } else if (response.outcome === "Duplicate name") {
                $.Notify.warn(i18n.t("customFieldDuplicateName"));
            } else if (response.outcome === "Custom Fields Length Exceeded") {
                $.Notify.warn(i18n.t("customFieldExceeded"));
            } else if (response.outcome === "Duplicate Custom Field") {
                $.Notify.warn(i18n.t("customFieldDuplicateName"));
            }  else {
                $.Notify.error(i18n.t("customFieldNotCreated"));
            }
            this.disableNewRedeemerFormButtons(false);
            if (selectElements) {
                for (let i = 0; i < selectElements.length; i++) {
                    $(selectElements[i]).find('option:last').before(`<option data-type="${type}" value="${name}" data-options="${data.values ? data.values.toString() : ''}">${name}</option>`);
                }
                if (selectElement) {
                    // select the newly add option, which is before the last option (lastOption = 'Create new Custom Field')
                    selectElement.value = name; //this mechanism, does not trigger change, so we do it manually, to show more info about the multiple choice available options
                    $(selectElement).trigger("change");
                }
                if (selfParam)
                    selfParam.validateCustomFields($(selectElement), selfParam);
            }
        }).fail(response => {
            console.error(response);
            dhtmlx.alert(response);
            this.disableNewRedeemerFormButtons(false);
        });
    }

    @on('click #cancelCreationOfCustomField')
    cancelCreationOfCustomField() {
        $("#name").val('');
        $("#newCustomFieldForm").hide();
    }

    @on('click #createCustomField')
    showNewCustomFieldForm() {
        const $cfForm = $("#newCustomFieldForm");
        $cfForm.find(".createField").show();
        $cfForm.find(".editField").hide();

        const $mChoicesContainer = $(".multipleChoiceOptions .sortableMChoices");
        $mChoicesContainer.empty();

        for(var index=0; index < 4; index++)
            $mChoicesContainer.append(this.customFieldMultipleChoiceOptionTemplate( {index: index} ));

        // set the "default" value of the dropdown
        $cfForm.find("#type").val("text");
        $cfForm.find("#type").trigger("change"); // trigger "change", because setting the value, change its selected option, but DOES NOT trigger "change" event
        $cfForm.show();
    }

    @on('click .editCustomField')
    async editCustomField(evt) {
        const $cfForm = $("#newCustomFieldForm");

        const name = $(evt.currentTarget).data("name");
        const type = $(evt.currentTarget).data("type");
        const id = $(evt.currentTarget).data("id");
        const mcOptions = $(evt.currentTarget).data("options").split(",");

        // set the appropriate info into a variable, so they can be used on submit
        this.customFieldInfo = {
            "name": name,
            "type": type,
            "id": id
        };

        const $mChoicesContainer = $(".multipleChoiceOptions .sortableMChoices");
        $mChoicesContainer.empty();

        for(var index=0; index < mcOptions.length; index++) {
            $mChoicesContainer.append(this.customFieldMultipleChoiceOptionTemplate( {index: index, value: mcOptions[index]} ));
        }

        $cfForm.find(".editField").show();
        $cfForm.find(".createField").hide();

        // set the name of the custom field, in the appropriate input
        $cfForm.find("#labelName").text(name);

        // select the `type` of the dropdown
        $cfForm.find("#type").val(type);
        $cfForm.find("#type").trigger("change"); // trigger "change", because setting the value, change its selected option, but DOES NOT trigger "change" event\
        $cfForm.show();
    }

    @on('click #submitEditCustomField')
    async updateCustomFieldValues(evt) {
        const $form = $("#newCustomFieldForm");
        const oldName = this.customFieldInfo.name;
        const id = parseInt(this.customFieldInfo.id);
        const oldType = this.customFieldInfo.type;

        const newName = $form.find("#name").val();
        const newType = $form.find("#type").val();

        var data = {
            name: oldName, // name can be changed directly by clicking on it
            type: newType
        };

        if (newType == "multipleChoice") {
            const mChoices = $form.find(".multipleChoiceOptions .customFieldMCOption");
            if(mChoices.length < 2) {
                dhtmlx.alert(i18n.t("customFieldAtLeastTwoChoices"));
                return;
            }

            var hasEmptyChoice = false;
            $.each(mChoices, function() {
                if($($(this)[0]).val().trim().length == 0) {
                    hasEmptyChoice = true;
                    $(this).addClass('invalidEmptyInput');
                }else {
                    $(this).removeClass('invalidEmptyInput');
                }
            });

            var hasDuplicateChoice = false;
            for(var i=0; i<mChoices.length; i++) {
                var curChoice = $(mChoices[i]).val();

                for(var j=0;j<mChoices.length; j++) {
                    var toCheck = $(mChoices[j]).val();
                    if(j != i) {
                        if(curChoice.toLowerCase() == toCheck.toLowerCase())
                            hasDuplicateChoice = true;
                    }
                }
            }

            if(hasEmptyChoice) {
                dhtmlx.alert(i18n.t("customFieldNoEmptyMultipleChoice"));
                return;
            }
            if(hasDuplicateChoice) {
                dhtmlx.alert(i18n.t("customFieldDuplicateMultipleChoice"));
                return;
            }
            data.values = $.map($(".multipleChoiceOptions").find("input"), function(input, index) {
                return $(input).val();
            });
        }

        if(oldType != newType) {
            const result = await dhtmlx.confirm({
                type: "confirm",
                text: i18n.t("customFieldChangeTypeNotification"),
                ok: i18n.t("continuebtn"),
                cancel: i18n.t("cancelbtn")
            });

            if (result) {
                this.updateCustomFieldRequest(id, data);
            }
        } else {
            this.updateCustomFieldRequest(id, data);
        }
    }

    updateCustomFieldRequest(id, data) {
        $.ajaxDefaultQ({
            url: `${this.collectionUrl}/${id}?type=${data.type}&name=${data.name}`,
            type: 'put',
            dataType: 'json',
            contentType: 'application/json',
            data: JSON.stringify(data.values)
        }).done(response => {
            if (response.outcome === "OK") {
                $.Notify.show(i18n.t("updateCustomFieldSuccessfully"));
                this.renderCollection();
            } else if (response.outcome === "Duplicate name") {
                $.Notify.warn(i18n.t("customFieldDuplicateName"));
            } else if (response.outcome === "Duplicate Custom Field Choice") {
                $.Notify.warn(i18n.t("customFieldDuplicateMultipleChoice"));
            } else if (response.outcome === "Empty Choices") {
                $.Notify.warn(i18n.t("customFieldNoEmptyMultipleChoice"));
            } else {
                $.Notify.error(i18n.t("updateCustomFieldUnsuccessfully"));
            }
        }).fail(response => {
            console.error(response);
            $.Notify.error("Error: " + response);
        });
    }

    @on('click .removeCustomField')
    async removeCustomField(evt) {
        const $customFieldRow = $(evt.currentTarget).closest('[data-custom-field-id]');
        const customFieldId = parseInt($customFieldRow.data("custom-field-id"));
        try {
            const result = await dhtmlx.modalbox({
                title: i18n.t("confirmCustomFieldRemovalTitle"),
                text: i18n.t("confirmCustomFieldRemoval"),
                buttons: [i18n.t("message.yes"), i18n.t("message.no")]
            });

            if (result !== "0") return;

            const response = await $.ajaxDefaultQ({
                url: `${this.collectionUrl}/${customFieldId}`,
                type: 'DELETE'
            });

            if (response.outcome === "OK") {
                $.Notify.show(i18n.t("customFieldRemovedSuccessfully"));
                this.renderCollection();
            } else {
                $.Notify.show(i18n.t("customFieldRemovedSuccessfully"));
            }
        } catch (e) {
            console.error(e);
            dhtmlx.alert(e);
        }
    }

    @on('click .updateCustomFieldName')
    updateCustomFieldName(evt) {
        const $customFieldRow = $(evt.currentTarget).closest('[data-custom-field-id]');
        const name = $customFieldRow.find(".updateCustomFieldNameInput").val();
        const customFieldId = parseInt($customFieldRow.data("custom-field-id"));
        if (!name)
            return;
        $.ajaxDefaultQ({
            url: `${this.collectionUrl}/${customFieldId}?name=${name}`,
            type: 'put',
            dataType: "json"
        }).done(response => {
            if (response.outcome === "OK") {
                $.Notify.show(i18n.t("updateCustomFieldNameSuccessfully"));
                this.renderCollection();
            } else if (response.outcome === "Duplicate name") {
                $.Notify.warn(i18n.t("customFieldDuplicateName"));
            } else {
                $.Notify.error(i18n.t("updateCustomFieldNameUnsuccessfully"));
            }
        }).fail(response => {
            console.error(response);
            $.Notify.error("Error: " + response);
        });
    }

    @on('click .currentCustomFieldName')
    editCustomFieldName(evt) {
        const $customFieldRow = $(evt.currentTarget).closest('[data-custom-field-id]');
        const currentName = $customFieldRow.find(".currentCustomFieldName").text();
        $customFieldRow.find(".updateCustomFieldNameInput").val(currentName);
        $customFieldRow.find(".editCustomFieldName").show();
        $customFieldRow.find(".currentCustomFieldName").hide();
        $customFieldRow.find(".updateCustomFieldNameInput").focus();
    }

    @on('click .cancelUpdateCustomFieldName')
    cancelUpdateCustomFieldName(evt) {
        const $customFieldRow = $(evt.currentTarget).closest('[data-custom-field-id]');
        $customFieldRow.find(".editCustomFieldName").hide();
        $customFieldRow.find(".currentCustomFieldName").show();
    }

    @on('click .cfMultipleChoiceOptions')
    toggleCFMultipleChoiceOptions(e) {
        // toggle class "open", to rotate the Arrow
        $(e.currentTarget).find("i").toggleClass("open");

        // toggle class "open", to show/hide options
        $(e.currentTarget).parent().find(".cfmcOptionsContainer").toggleClass("open");
    }

    @on('click .addMCCFAnswer')
    async addMCCFAnswer(input) {
        const $input = $(input.currentTarget);
        let index = $input.prev().children().find("input").length;
        $input.prev().append(this.customFieldMultipleChoiceOptionTemplate({index: index}));

        // scroll to bottom and focus on the newly added field, each time a new option is added, to enhance UX
        $input.parent().parent().scrollTop($input.parent().parent().height());
        $input.prev().children().find("input").last().focus();

        //bind Delete MultipleChoice Option, while creating custom field, in contact upload
        if($("#upload-options").length > 0)
            $input.prev().children().find("input").last().parent().find("button").off("click").click(this.deleteMCCFAnswer.bind(this));
    }

    @on('click .deleteMCCFAnswer')
    async deleteMCCFAnswer(input) {
        const $input = $(input.currentTarget);
        let indexComponent = $input.attr("id").replace(/[^0-9.]+/g, "");
        try {
            const result = await dhtmlx.modalbox({
                title: i18n.t("survey.confirmdeletion"),
                text: i18n.t("survey.areyousuretodelete"),
                buttons: [i18n.t("message.yes"), i18n.t("message.no")]
            });
            if (result === "0") {
                $.map($(".multipleChoiceOptions").find("input"), function(input2, index) {
                    let indexInput2 = $(input2).attr("id").replace(/[^0-9.]+/g, "");
                    if (indexInput2 > indexComponent) {
                        $(input2).attr("id", `insert-component-${indexInput2 - 1}`);
                        $(input2).next().attr("id", `delete-component-${indexInput2 - 1}`);
                    }
                });
                $(`#delete-component-${indexComponent}`).parent().remove();
            }
        }catch (e) {
            console.info(e);
        }

    }
}

export default CustomFieldsView;
